if (!customElements.get('leslis-spooky-toggle')) {
  // Preserve the visitor's existing choice when moving the switch into the header.
  const storageKey = 'leslis-spooky-october-v1';
  let stylesPromise;

  function loadStyles(href) {
    if (stylesPromise) return stylesPromise;
    stylesPromise = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = () => {
        link.remove();
        stylesPromise = null;
        reject(new Error('Styles unavailable'));
      };
      document.head.append(link);
    });
    return stylesPromise;
  }

  customElements.define('leslis-spooky-toggle', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.initialized = true;
        this.generation = (this.generation || 0) + 1;
        this.status = this.querySelector('[data-spooky-status]');
        this.onClick = () => this.toggle();
        const active = document.documentElement.classList.contains('leslis-spooky');
        this.button.setAttribute('aria-checked', String(active));
        this.toggleAttribute('data-on', active);
        this.button.addEventListener('click', this.onClick);
        this.hidden = false;
        if (active) this.toggle(false);
      });
    }

    save(on) {
      try {
        on ? sessionStorage.setItem(storageKey, 'on') : sessionStorage.removeItem(storageKey);
      } catch (_) {}
    }

    async toggle(announce = true) {
      if (this.button.getAttribute('aria-busy') === 'true') return;
      if (this.controller) { this.controller.toggle(); return; }
      const generation = this.generation;
      this.button.setAttribute('aria-busy', 'true');
      try {
        const [, module] = await Promise.all([loadStyles(this.dataset.css), import(this.dataset.module)]);
        if (!this.isConnected || generation !== this.generation) return;
        this.controller = module.createSpookyMode(this, (on) => this.save(on));
        this.controller.setActive(true, announce);
      } catch (_) {
        if (this.isConnected && generation === this.generation) {
          this.status.textContent = this.dataset.error;
          document.documentElement.classList.remove('leslis-spooky');
          document.body.classList.remove('leslis-spooky');
          this.button.setAttribute('aria-checked', 'false');
          this.removeAttribute('data-on');
          this.save(false);
        }
      } finally {
        if (generation === this.generation) this.button.removeAttribute('aria-busy');
      }
    }

    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.button?.removeEventListener('click', this.onClick);
      this.button?.removeAttribute('aria-busy');
      this.controller?.destroy();
      this.controller = null;
      this.initialized = false;
    }
  });
}
